import React from 'react';
import { DataTable } from 'react-native-paper';
import PropTypes from 'prop-types';

function WaterUseDataTablePagination({
  crops,
  from,
  itemsPerPage,
  language,
  page,
  pageCrops,
  setPage,
}) {
  const of = language === 'en' ? 'of' : language === 'es' ? 'de' : 'TRANSLATE';
  return (
    <DataTable.Pagination
      page={page}
      numberOfPages={Math.ceil(crops.length / itemsPerPage)}
      onPageChange={(page) => setPage(page)}
      label={`${from + 1}-${from + pageCrops.length} ${of} ${crops.length}`}
    />
  );
}

WaterUseDataTablePagination.propTypes = {
  crops: PropTypes.array,
  from: PropTypes.number,
  itemsPerPage: PropTypes.number,
  page: PropTypes.number,
  pageCrops: PropTypes.arrayOf(PropTypes.object),
  setPage: PropTypes.func,
};

export default WaterUseDataTablePagination;
